import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import UserContext from '../AppLocals/User/UserContext'
import {renderIf} from "../Shared";
import {getId} from 'apis/model/base'
import UserOrganizations from "../AppLocals/User/components/UserOrganizations";
import UserChannels from "../AppLocals/User/components/UserChannels";

const UserActivities = ({}) => {
    const t = useTranslate()

    const {user} = useContext(UserContext)

    return (
        <div className="flex flex-col gap-6">
            <UserChannels
                user_id={getId(user)}
                renderWrap={(child, __, count) =>
                    renderIf(
                        count,
                        <div className="flex flex-col gap-3">
                            <div className="font-medium text-sm text-color-500 border-b tracking-wide uppercase">
                                {t('channels')}
                            </div>
                            {child}
                        </div>
                    )
                }
            />
            <UserOrganizations
                user_id={getId(user)}
                renderWrap={(child, __, count) =>
                    renderIf(
                        count,
                        <div className="flex flex-col gap-3">
                            <div className="font-medium text-sm text-color-500 border-b tracking-wide uppercase">
                                {t('admin of organizations')}
                            </div>
                            {child}
                        </div>
                    )
                }
            />
        </div>
    )
}

export default UserActivities
